import React, {useState} from 'react'
import axios from 'axios'

function ServiciosItemDetalle(props) {
  const servicio = props.servicio

  const [inputFile, setInputFile] = useState('')
  const [tituloInput, setTituloInput] = useState('')
  const [descInput, setDescInput] = useState('')

  let idElementoNum = servicio.idElement.split('-')[2]
  let tituloString = servicio.title
  let descString = servicio.description

  const onChangeImage = (event) => {
    setInputFile(event.target.files)
    const [file] = event.target.files
    if (file) {
      document
        .getElementsByClassName('home-servicios-' + idElementoNum)[0]
        .setAttribute('src', URL.createObjectURL(file))
      document.getElementById('ribbon-servicios-' + idElementoNum).classList.remove('d-none')
    }
  }

  const onChangeTitulo = (event) => {
    setTituloInput(event.target.value)
    document.getElementById('ribbon-servicios-' + idElementoNum).classList.remove('d-none')
  }

  const onChangeDesc = (event) => {
    setDescInput(event.target.value)
    document.getElementById('ribbon-servicios-' + idElementoNum).classList.remove('d-none')
  }

  const onSubmit = () => {
    // if (!inputFile) {
    //   alert('Seleccione un archivo')
    //   return false
    // }

    let url = 'https://puntosurgdl.com/backend/'

    const data = new FormData()

    for (let i = 0; i < inputFile.length; i++) {
      data.append('file[]', inputFile[i])
    }

    data.append('name', servicio.idElement)
    data.append('title', document.getElementById('titulo-servicios-' + idElementoNum).value)
    data.append(
      'description',
      document.getElementById('descripcion-servicios-' + idElementoNum).value
    )

    axios
      .post(url + 'uploadService.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res)
          document.getElementById('ribbon-servicios-' + idElementoNum).classList.add('d-none')
        },
        (error) => {
          alert(error)
        }
      )
  }

  return (
    <div className='col-lg-2 servicioitem' key={servicio.idELement}>
      <div className='card card-custom overlay overflow-hidden'>
        <div className='card-body p-0 ribbon'>
          <div id={'ribbon-servicios-' + idElementoNum} className='ribbon-label bg-danger d-none'>
            Sin guardar
          </div>
          <div className='overlay-wrapper'>
            <img
              src={servicio.url}
              alt=''
              className={'w-100 rounded img-home-servicios home-servicios-' + idElementoNum}
            />
          </div>
          <div className='overlay-layer bg-dark bg-opacity-10'>
            <div className='d-flex flex-grow-1 flex-center py-5'>
              <input
                type='file'
                id={'file-servicios-' + idElementoNum}
                name={'file-servicios-' + idElementoNum}
                className='input-image'
                onChange={(event) => onChangeImage(event)}
              />
              <input
                id='button'
                type='button'
                value='Cambiar...'
                className='btn btn-light-primary'
                onClick={() => document.getElementById('file-servicios-' + idElementoNum).click()}
              />
            </div>
          </div>
        </div>
      </div>
      <label className='form-label mt-6'>Titulo</label>
      <input
        id={'titulo-servicios-' + idElementoNum}
        name={'titulo-servicios-' + idElementoNum}
        className='form-control'
        defaultValue={tituloString}
        type='text'
        onChange={(e) => onChangeTitulo(e)}
      />
      <label className='form-label mt-6'>Link</label>
      <input
        id={'descripcion-servicios-' + idElementoNum}
        name={'descripcion-servicios-' + idElementoNum}
        className='form-control'
        defaultValue={descString}
        type='text'
        onChange={(e) => onChangeDesc(e)}
      />
      <div className='mt-4 float-end'>
        <button className='btn btn-primary btn-sm' onClick={() => onSubmit()}>
          Guardar
        </button>
        <button className='btn btn-danger float-end btn-sm d-none'>Eliminar</button>
      </div>
    </div>
  )
}

export {ServiciosItemDetalle}
